<template>
	<div class="contents-list-page">
		<div class="action-buttons">
			<AddContentButton color="#1877F2" @click="onClickAddVouchers">Add Voucher</AddContentButton>
		</div>
		<ContentsList ref="contentsList" @edit="onEditContent" :types="['voucher']" :emptyText="emptyText" />
		<transition name="fade">
			<VoucherForm v-if="showVoucherForm" @close="onCloseVoucher" :content="content" />
		</transition>
	</div>
</template>

<script>
import AddContentButton from '@/components/AddContentButton';
import VoucherForm from '@/components/VoucherForm';
import ContentsList from '@/components/ContentsList';
export default {
	components: {
		AddContentButton,
		VoucherForm,
		ContentsList,
	},
	data() {
		return {
			showVoucherForm: false,
            content: null,
            emptyText: "This account has no voucher yet. Please press the ADD button above"
		};
	},
	methods: {
		onClickAddVouchers() {
			this.showVoucherForm = true;
		},
		onCloseVoucher() {
			this.showVoucherForm = false;
			this.reload();
		},
		reload() {
			this.content = null;
			this.$refs.contentsList.reload();
		},
		async onEditContent(id, type) {
			this.content = await this.$repo.voucher.getVoucher(id);
			this.showVoucherForm = true;
		},
	},
};
</script>

<style scoped lang="scss">
.contents-list-page {
	margin: 30px 70px;
	padding-bottom: 50px;

	.add-content-button + .add-content-button {
		margin-left: 34px;
	}
}
</style>
